import { BrowserRouter as Router, Switch, Routes, Route } from 'react-router-dom';
import { EditingCam } from './pages/editingCam';
import { Home } from './pages/home/Home';
import { Login } from './pages/login/login';
import ManagementRegionalPage from './pages/managementRegionalPage';


export default function RoutesApp() {
    return (
        <Routes>
            <Route 
            exact
            path='/login'
            element={<Login />}
            />
            <Route 
            exact
            path='/'
            element={<Home />}
            />
            <Route 
            exact
            path='/editar-camera/:idCam'
            element={<EditingCam />}
            />
            <Route 
            exact
            path='/nova-regional'
            element={<ManagementRegionalPage />}
            />
        </Routes>
    )
} 